import {
  Liability,
  LiabilityActionType,
} from 'src/components/Loan/Application/Sections/AssetsLiabilitiesInfo/Inputs/Liabilities/store/types';

type LiabilityStore = Liability[];

const defaultState: LiabilityStore = [];

const reducer = (
  state: LiabilityStore = defaultState,
  { type, data }: { type: LiabilityActionType; data: any },
): LiabilityStore => {
  switch (type) {
    // @ts-ignore
    case 'clear_loan_data':
      return defaultState;
    case LiabilityActionType.SET: {
      const items = [...state];
      for (const item of data) {
        const matchIndex = state.findIndex((x) => x.id === item.id);
        if (matchIndex > -1) {
          items.splice(matchIndex, 1, {
            ...items[matchIndex],
            ...item,
          });
        } else {
          items.push(item);
        }
      }
      return items;
    }
    case LiabilityActionType.UPDATE: {
      const matchIndex = state.findIndex((x) => x.id === data.id);
      const items = [...state];

      items.splice(matchIndex, 1, {
        ...items[matchIndex],
        ...data,
      });
      return items;
    }
    case LiabilityActionType.ADD: {
      const items = [...state, data];
      return items;
    }
    case LiabilityActionType.DELETE: {
      const matchIndex = state.findIndex((x) => x.id === data);
      const items = [...state];
      items.splice(matchIndex, 1);
      return items;
    }
    default:
      return state;
  }
};

export default reducer;
